// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2897 ? "sentry" : chunkId) + ".legacy." + {"2897":"a37b371dad319d477b44","6400":"8ad557cb354770755570"}[chunkId] + ".js";
};